import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');
        setMessage('');
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message);
            setMessage(data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center ...">
            <div className="max-w-md w-full space-y-8">
                <div className="bg-white ... p-8 rounded-2xl ...">
                    <h2 className="text-2xl font-bold ...">Reset Your Password</h2>
                    <p className="mt-2 text-sm text-gray-500">Enter your email address and we will send you a link to reset your password.</p>
                    <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" required className="..." />
                        {message && <p className="text-green-500">{message}</p>}
                        {error && <p className="text-red-500">{error}</p>}
                        <button type="submit" disabled={isSubmitting} className="w-full ...">
                            {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </form>
                    <div className="text-center mt-4">
                        <Link to="/login" className="text-sm font-medium text-orange-600 ...">&larr; Back to Sign In</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}